function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Button, Column, Icon, Menu, Phrase, Row, Spacer, Tooltip } from "@neru/ui";
import { classNames } from "@neru/utils";
import { useAuthService } from "pkce-hook";
import { useEffect } from "react";
import { Link, matchRoutes, useLocation, useNavigate } from "react-router-dom";
import { useToggle } from "react-use";
import { AccountSelector, RegionSelector } from "../../components";
import { mainNavigationConfig as conf } from "../../config";
import { FEATURE_FLAGS, useFeatureToggle, useMenu, useValidSession } from "../../hooks";
import { URL, Validators } from "../../utils";
import { Announcements } from "../Announcements/Announcements";
export var MENU_KEYS = /*#__PURE__*/ function(MENU_KEYS) {
    MENU_KEYS["/assets"] = "assets";
    MENU_KEYS["/deployed-products"] = "deployedProducts";
    MENU_KEYS["/documentation"] = "documentation";
    MENU_KEYS["/instances"] = "instances";
    MENU_KEYS["/overview"] = "overview";
    MENU_KEYS["/vulnerabilities"] = "vulnerabilities";
    MENU_KEYS["/workspaces"] = "workspaces";
    MENU_KEYS["dashboard"] = "dashboard";
    MENU_KEYS["market"] = "market";
    return MENU_KEYS;
}({});
export var MAIN_NAVIGATION_HEIGHT = "3.5rem";
var routesToCollapseMenu = [
    {
        path: "/workspaces/:workspaceId"
    }
];
export var getActiveMenuItem = function(pathname) {
    var key = Object.keys(MENU_KEYS).find(function(key) {
        return pathname.startsWith(key);
    });
    if (key) {
        return MENU_KEYS[key];
    }
};
var getWorkspaceId = function(pathname) {
    var _pathname_split_pop;
    return (_pathname_split_pop = pathname.split("/").pop()) === null || _pathname_split_pop === void 0 ? void 0 : _pathname_split_pop.split("_")[0];
};
var validateUUID = function(pathname) {
    var _getWorkspaceId;
    return import.meta.env.MODE === "production" ? Validators.isUUID(getWorkspaceId(pathname)) : Boolean((_getWorkspaceId = getWorkspaceId(pathname)) === null || _getWorkspaceId === void 0 ? void 0 : _getWorkspaceId.includes("-"));
};
var MainNavigationControls = function(param) {
    var hasValidSession = param.hasValidSession, withAccountSelector = param.withAccountSelector, withRegionSelector = param.withRegionSelector, withSignIn = param.withSignIn;
    var authService = useAuthService();
    var location = useLocation();
    var hash = location.hash, pathname = location.pathname;
    var _useFeatureToggle = _sliced_to_array(useFeatureToggle(FEATURE_FLAGS.accountOverview), 1), isAccountOverviewOn = _useFeatureToggle[0];
    var login = function() {
        localStorage.setItem("vch.navigate_to", pathname + hash);
        authService.login();
    };
    var logout = function() {
        authService.logout(true);
    };
    var signUp = function() {
        localStorage.setItem("vch.navigate_to", pathname + hash);
        window.location.replace("".concat(conf.urlSignUp, "?return_to=").concat(window.location, "?register=true"));
    };
    if (!withAccountSelector && !withRegionSelector) return;
    if (hasValidSession) {
        return /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                /*#__PURE__*/ _jsxs(Row, {
                    className: "flex-nowrap items-center justify-end",
                    children: [
                        withRegionSelector && /*#__PURE__*/ _jsxs(_Fragment, {
                            children: [
                                /*#__PURE__*/ _jsx(Tooltip, {
                                    placement: "bottom",
                                    text: "Change region",
                                    children: /*#__PURE__*/ _jsx(Icon, {
                                        size: "small",
                                        type: "globe-line"
                                    })
                                }),
                                /*#__PURE__*/ _jsx(Spacer, {
                                    size: "md"
                                }),
                                /*#__PURE__*/ _jsx(RegionSelector, {
                                    width: 200
                                })
                            ]
                        }),
                        withAccountSelector && /*#__PURE__*/ _jsxs(_Fragment, {
                            children: [
                                /*#__PURE__*/ _jsx(Spacer, {
                                    size: "lg"
                                }),
                                /*#__PURE__*/ _jsx(Tooltip, {
                                    placement: "bottom",
                                    text: "Manage or change account",
                                    children: /*#__PURE__*/ _jsx(Icon, {
                                        size: "small",
                                        type: "user-line"
                                    })
                                }),
                                /*#__PURE__*/ _jsx(Spacer, {
                                    size: "md"
                                }),
                                /*#__PURE__*/ _jsx(AccountSelector, {
                                    withMenu: true
                                })
                            ]
                        })
                    ]
                }),
                isAccountOverviewOn && /*#__PURE__*/ _jsx(Column, {
                    className: "relative ml-6",
                    children: /*#__PURE__*/ _jsx(Announcements, {})
                }),
                import.meta.env.MODE === "production" && withSignIn && /*#__PURE__*/ _jsxs(_Fragment, {
                    children: [
                        /*#__PURE__*/ _jsx(Spacer, {
                            size: "sm"
                        }),
                        /*#__PURE__*/ _jsx(Button, {
                            connotation: "primary",
                            "data-testid": "sign-out",
                            label: "Sign out",
                            layout: "ghost",
                            onClick: logout,
                            type: "submit"
                        })
                    ]
                })
            ]
        });
    }
    if (withSignIn) {
        return /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                /*#__PURE__*/ _jsx(Button, {
                    connotation: "primary",
                    "data-testid": "sign-in",
                    label: "Sign in",
                    layout: "ghost",
                    onClick: login,
                    type: "submit"
                }),
                /*#__PURE__*/ _jsx(Spacer, {}),
                /*#__PURE__*/ _jsx(Button, {
                    connotation: "cta",
                    "data-testid": "sign-up",
                    label: "Sign up",
                    layout: "filled",
                    onClick: signUp,
                    type: "submit"
                })
            ]
        });
    }
};
export var MainNavigation = function(param) {
    var active = param.active, children = param.children, logo = param.logo, _param_theme = param.theme, theme = _param_theme === void 0 ? "dark" : _param_theme, _param_withAccountSelector = param.withAccountSelector, withAccountSelector = _param_withAccountSelector === void 0 ? false : _param_withAccountSelector, _param_withRegionSelector = param.withRegionSelector, withRegionSelector = _param_withRegionSelector === void 0 ? false : _param_withRegionSelector, _param_withSignIn = param.withSignIn, withSignIn = _param_withSignIn === void 0 ? false : _param_withSignIn;
    var location = useLocation();
    var pathname = location.pathname;
    var hasValidSession = useValidSession();
    var collapsedTitle = useMenu().collapsedTitle;
    var navigate = useNavigate();
    var _useFeatureToggle = _sliced_to_array(useFeatureToggle(FEATURE_FLAGS.vulnerabilities), 1), isVulnerabilitiesOn = _useFeatureToggle[0];
    var getMenuItems = function(appName, param) {
        var hasValidSession = param.hasValidSession;
        var menuItems = [];
        if (appName === "market") {
            menuItems.push({
                action: "/",
                key: "market",
                title: "Home"
            });
        }
        if (hasValidSession && [
            "customer",
            "market"
        ].includes(appName)) {
            menuItems.push({
                action: conf.urlWorkspaces,
                key: "workspaces",
                title: "Workspaces"
            }, {
                action: conf.urlInstances,
                key: "instances",
                title: "Instances"
            });
        }
        if (hasValidSession && appName === "market") {
            menuItems.push({
                action: conf.urlDeployedProducts,
                key: "deployedProducts",
                title: "Deployed Products"
            });
            if (isVulnerabilitiesOn) {
                menuItems.push({
                    action: conf.urlVulnerabilities,
                    key: "vulnerabilities",
                    title: "Vulnerabilities"
                });
            }
        }
        if (appName === "market") {
            menuItems.push({
                action: "".concat(window.location.origin).concat(conf.urlDocumentation),
                key: "documentation",
                title: "Documentation"
            });
        }
        if (appName === "customer") {
            menuItems.push({
                action: conf.urlAssets,
                key: "assets",
                title: "Assets"
            });
        }
        return menuItems;
    };
    var isCollapsible = Boolean(matchRoutes(routesToCollapseMenu, location)) && validateUUID(location.pathname);
    var _useToggle = _sliced_to_array(useToggle(isCollapsible), 2), collapse = _useToggle[0], toggleCollapse = _useToggle[1];
    var Logo = logo ? function() {
        return /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                logo,
                /*#__PURE__*/ _jsx(Spacer, {})
            ]
        });
    } : function() {
        return /*#__PURE__*/ _jsx(_Fragment, {});
    };
    useEffect(function() {
        toggleCollapse(isCollapsible);
    }, [
        isCollapsible,
        toggleCollapse
    ]);
    useEffect(function() {
        var mainContent = document.getElementById("main-content");
        if (!mainContent) return;
        if (collapse) {
            mainContent.style.marginTop = "0px";
        } else {
            mainContent.style.marginTop = MAIN_NAVIGATION_HEIGHT;
        }
    }, [
        collapse
    ]);
    var onMenuOptionSelected = function(action) {
        return _async_to_generator(function() {
            return _ts_generator(this, function(_state) {
                if (pathname === action) return [
                    2
                ];
                if (URL.isAbsoluteURL(action)) {
                    window.location.href = action;
                } else {
                    navigate(action);
                }
                return [
                    2
                ];
            });
        })();
    };
    var _localStorage_getItem;
    var menuItems = getMenuItems((_localStorage_getItem = localStorage.getItem("vch.app_name")) !== null && _localStorage_getItem !== void 0 ? _localStorage_getItem : "", {
        hasValidSession: hasValidSession
    });
    var listItemClassName = "mx-2 flex items-center text-center";
    var linkClassName = "flex items-center justify-center px-2 border-b-2 border-transparent text-primary-1000 dark:text-primary-0 no-underline hover:border-accent-active hover:text-accent-active active:border-accent-active active:text-accent-active";
    return /*#__PURE__*/ _jsx("div", {
        className: classNames("sticky top-0 w-full z-10", theme === "dark" && "dark"),
        children: collapse ? /*#__PURE__*/ _jsx(Row, {
            className: "\n            bg-primary-0\n            dark:bg-primary-1000\n          ",
            onClick: toggleCollapse,
            children: /*#__PURE__*/ _jsx(Tooltip, {
                placement: "bottom",
                text: "Expand menu",
                children: /*#__PURE__*/ _jsxs(Row, {
                    className: "pl-md ml-16 cursor-pointer items-center",
                    children: [
                        /*#__PURE__*/ _jsx(Icon, {
                            className: "\n                  fill-primary-1000\n                  dark:fill-primary-0\n                ",
                            "data-testid": "expand-icon",
                            size: "small",
                            type: "chevron-down-solid"
                        }),
                        /*#__PURE__*/ _jsx(Spacer, {
                            size: "xs"
                        }),
                        collapsedTitle ? /*#__PURE__*/ _jsx(Phrase, {
                            className: '\n                    bg-primary-200 text-primary-1000 relative ml-2 py-px pr-2\n                    pl-6 leading-[18px] whitespace-nowrap\n                    after:border-l-primary-200 after:absolute after:top-0\n                    after:right-[-9px] after:border-t-[9px] after:border-b-[9px]\n                    after:border-l-[9px] after:border-solid\n                    after:border-t-transparent after:border-r-transparent\n                    after:border-b-transparent\n                    before:border-l-primary-0 before:absolute before:top-0\n                    before:left-0 before:border-t-[9px] before:border-b-[9px]\n                    before:border-l-[9px] before:border-solid\n                    before:border-t-transparent before:border-r-transparent\n                    before:border-b-transparent before:content-[""]\n                    dark:bg-primary-700 dark:text-primary-0\n                    dark:before:border-l-primary-1000\n                    dark:after:border-l-primary-700\n                  ',
                            children: collapsedTitle
                        }) : null
                    ]
                })
            })
        }) : /*#__PURE__*/ _jsxs("nav", {
            className: "\n            main-navigation bg-primary-0 text-primary-1000 fixed\n            top-(--bifrost-header-height,0px) z-10 box-border flex h-14 w-full\n            items-center justify-between px-6 py-2 text-sm shadow-md\n            dark:bg-primary-1000 dark:text-primary-0\n          ",
            "data-testid": "main-navigation",
            id: "main-navigation",
            children: [
                /*#__PURE__*/ _jsx(Logo, {}),
                isCollapsible && /*#__PURE__*/ _jsxs(_Fragment, {
                    children: [
                        /*#__PURE__*/ _jsx(Tooltip, {
                            placement: "bottom",
                            text: "Collapse menu",
                            children: /*#__PURE__*/ _jsx(Button, {
                                connotation: "primary",
                                "data-testid": "collapse-icon",
                                icon: "chevron-up-solid",
                                onClick: toggleCollapse,
                                size: "condensed"
                            })
                        }),
                        /*#__PURE__*/ _jsx(Spacer, {
                            size: "sm"
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx(Row, {
                    className: "\n              grow\n              lg:hidden\n            ",
                    children: /*#__PURE__*/ _jsx(Menu, {
                        "data-testid": "menu-dropdown",
                        icon: "list-line",
                        menuItems: menuItems,
                        onAction: onMenuOptionSelected
                    })
                }),
                /*#__PURE__*/ _jsx(Row, {
                    className: "\n              hidden grow\n              lg:flex\n            ",
                    children: /*#__PURE__*/ _jsx("ol", {
                        className: "m-0 flex w-full list-none justify-start p-0",
                        "data-testid": "menu-list",
                        children: children ? children.map(function(child) {
                            return /*#__PURE__*/ _jsx("li", {
                                className: listItemClassName,
                                children: child
                            }, child.toString());
                        }) : menuItems.map(function(param) {
                            var action = param.action, key = param.key, title = param.title;
                            var link = URL.isAbsoluteURL(action) ? /*#__PURE__*/ _jsx("a", {
                                className: classNames(linkClassName, key === active && "active"),
                                href: action,
                                children: title
                            }) : /*#__PURE__*/ _jsx(Link, {
                                className: classNames(linkClassName, key === active && "active"),
                                to: action,
                                children: title
                            });
                            return /*#__PURE__*/ _jsx("li", {
                                className: listItemClassName,
                                children: action === pathname ? /*#__PURE__*/ _jsx("span", {
                                    className: "\n                              active flex cursor-default items-center\n                              justify-center border-b-2 border-transparent px-2\n                            ",
                                    "data-testid": "active-menu-item",
                                    children: title
                                }) : link
                            }, key);
                        })
                    })
                }),
                /*#__PURE__*/ _jsx(MainNavigationControls, {
                    hasValidSession: hasValidSession,
                    withAccountSelector: withAccountSelector,
                    withRegionSelector: withRegionSelector,
                    withSignIn: withSignIn
                })
            ]
        })
    });
};

//# sourceMappingURL=MainNavigation.js.map